import { Component, Input, OnInit } from '@angular/core';
import { Fases } from 'src/app/models/fases.model';

@Component({
  selector: 'app-fase',
  templateUrl: './fase.component.html',
  styleUrls: ['./fase.component.css']
})
export class FaseComponent implements OnInit {
  fase1 = true;
  fase2 = false;
  fase3 = false;
  fase4 = false;
  fase5 = false;
  fase6 = false;
  fase7 = false;
  @Input() lista: Fases;

  constructor() {
    // This is intentional
  }

  ngOnInit(): void {
    // This is intentional
  }

}
